import { Icon } from "./Icon";

interface FABProps {
  onClick: () => void;
  className?: string;
}

/**
 * Floating Action Button component with frosted glass effect.
 * Fixed position: bottom-20 right-4 (mobile) / bottom-6 right-6 (desktop)
 */
export function FAB({ onClick, className = "" }: FABProps) {
  return (
    <button
      onClick={onClick}
      className={`
        fixed z-40 w-14 h-14 rounded-full
        bg-surface-blur backdrop-blur-md
        shadow-lg
        flex items-center justify-center
        transition-transform duration-200 hover:scale-105
        bottom-20 right-4 md:bottom-6 md:right-6
        ${className}
      `}
      aria-label="Create new"
    >
      <Icon name="circle-plus" size={28} className="text-text-primary" />
    </button>
  );
}
